/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:438px;height:442px}section[_ngcontent-%COMP%]{width:438px;height:442px;background-size:100% 100%;position:relative}.light[_ngcontent-%COMP%]{background-image:url(/assets/overlay/light-world.png)}.dark[_ngcontent-%COMP%]{background-image:url(/assets/overlay/dark-world.png)}\n/*# sourceMappingURL=world.component.css.map*/"];
export { styles as styles };
